<template>
  <table class="suspected-players-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Ид</th>
        <th scope="col">Имя</th>
        <th scope="col" class="text-right">Монеты</th>
        <th scope="col" class="text-right">Звезды</th>
        <th scope="col">Доступ к событиям</th>
        <th scope="col">Последний вход</th>
        <th scope="col">Подозрительная активность</th>
      </tr>
    </thead>
    <tr
      v-for="player in players"
      :key="player.id"
    >
      <td>
        <player-link :playerId="player.id" label=""/>
      </td>
      <td>
        {{player.name}}
      </td>
      <td class="text-right">
        {{player.money | getFormattedNumber}}
      </td>
      <td class="text-right">
        {{player.starAmount | getFormattedNumber}}
      </td>
      <td :class="getEventAccessStatusClass(player.eventAccessStatus)">
        {{player.eventAccessStatus | getEventAccessStatusName}}
      </td>
      <td>
        {{player.lastLoginTime | getMomentStr}}
      </td>
      <td>
        <suspicious-activity-list
          :activities="convertSuspiciousActivityMaskToList(player.suspicionsMask)"
        />
      </td>
    </tr>
  </table>
</template>

<script>
import { convertSuspiciousActivityMaskToList } from '../model/player.js';

import { getEventAccessStatusNameRu as getEventAccessStatusName      } from '../model/event_access.js';
import { getEventAccessStatusClass                                   } from '../model/event_access.js';

import PlayerLink from './PlayerLink.vue';
import SuspiciousActivityList from './SuspiciousActivityList.vue';

export default {
  name: 'SuspectedPlayersTable',

  components: {
    PlayerLink,
    SuspiciousActivityList,
  },

  props: {
    players: {
      type: Array,
      required: true,
    },
  },

  methods: {
    convertSuspiciousActivityMaskToList,
    getEventAccessStatusClass,
  },

  filters: {
    getEventAccessStatusName,
  },
}
</script>

<style scoped>
.suspected-players-table {
  width: 1px;
}

.suspected-players-table > tr:last-child > td {
  border-bottom: 1px solid #dee2e6;
}
</style>
